import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-preregister',
  templateUrl: './preregister.component.html',
  styleUrls: ['./preregister.component.scss'],
})
export class PreregisterComponent implements OnInit {

  languageConext: any;
  context: any;
  headerimg: any ="";

  constructor(public api : RestapiService,public navctrl: NavController, public platform: Platform, public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService, public router: Router) {
    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].landingpage;
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].landingpage;
    }
    console.log(this.languageConext);
    this.headerimg = this.languageConext.hdrimg.lbldata;
    this.api.postapi("getPopupConfigs",{}).then(data=>{
      console.log(data);
      localStorage.configPage = JSON.stringify(data);
    },err=>{
      console.log("err");
    })
  }

  ngOnInit() {
  }

  redirectPage(pageFlg: any) {
    if (pageFlg == 'login') {
      sessionStorage.CurrentPage = "/login";
      this.navctrl.navigateForward("/login");
    }else if(pageFlg == 'existingcustomer'){
      sessionStorage.CurrentPage = "/existingCustomer";
      this.navctrl.navigateForward("/existingCustomer");
    }else if(pageFlg == 'newuser'){
      sessionStorage.CurrentPage = "/prospectuser";
      this.navctrl.navigateForward("/prospectuser");
    }else if(pageFlg == 'claim'){
      sessionStorage.CurrentPage = "/claim";
      this.navctrl.navigateForward("/claim");
    }

  }

}
